var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.data.length > 0 ? _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.data,
      bordered: "",
      pagination: false,
      rowKey: "id",
      defaultExpandAllRows: true
    },
    scopedSlots: _vm._u([{
      key: "menu",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "expandedRowRender",
      fn: function (record, i) {
        return _c("div", {
          staticStyle: {
            margin: "0"
          }
        }, _vm._l(record.list, function (item, index) {
          return _c("div", {
            key: index,
            style: record.list.length - 1 != index ? "margin-bottom:20px" : ""
          }, [_c("div", [_c("a-checkbox", {
            attrs: {
              checked: item.allSelected
            }
          }, [_vm._v(_vm._s(_vm.$t("全部")))]), _vm._l(item.permissionsGroup, function (item2, index2) {
            return _c("a-checkbox", {
              key: index2,
              attrs: {
                checked: item2.selected
              }
            }, [_c("a-tooltip", {
              attrs: {
                placement: "top"
              }
            }, [_c("template", {
              slot: "title"
            }, [_c("span", [_vm._v(_vm._s(_vm.$t(item2.description)))])]), _vm._v(" " + _vm._s(_vm.$t(item2.name)) + " ")], 2)], 1);
          })], 2)]);
        }), 0);
      }
    }], null, false, 4108410722)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _vm.fieldConfigurationShow ? _c("field-configuration-model", {
    ref: "fieldConfiguration",
    on: {
      cancel: function ($event) {
        _vm.fieldConfigurationShow = false;
      },
      ok: _vm.handleSure
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };